import { CSSInterpolation } from '@emotion/serialize';
import * as React from 'react';
import { FontWeight } from '../../theme/tokens';

type HTMLAttributes = React.HTMLAttributes<HTMLLegendElement>;

export type LegendProps = HTMLAttributes;

const legendStyle: CSSInterpolation = {
  fontWeight: FontWeight.SemiBold,
  display: 'block',
  padding: 0,
  margin: 0,
};

const Legend: React.FC<LegendProps> = (props) => {
  return (
    <legend css={legendStyle} {...props}>
      {props.children}
    </legend>
  );
};

export default Legend;
